@if (loader.isLoading) {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">{{loader.message}}</div>
  </div>
}
@if (errorMessage) {
  <div class="error-container">
    <div class="loader-message">{{errorMessage}}</div>
  </div>
}
@if (!loader.isLoading && !errorMessage) {
  <section class="dt-calculator-page">
    <div class="form-grid" [formGroup]="selectionForm">

      <mat-form-field class="form-group span4">
        <mat-label>Company</mat-label>
        <mat-select formControlName="company_id" (selectionChange)="onCompanyChange($event.value)">
          <mat-option value="" disabled>-- Select Company --</mat-option>
          @for (company of companyList; track company.company_id) {
            <mat-option [value]="company.company_id">{{ company.company_code }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-group span4">
        <mat-label>Plant</mat-label>
        <mat-select formControlName="plant_id" (selectionChange)="onPlantChange($event.value)">
          <mat-option value="" disabled>-- Select Plant --</mat-option>
          @for (plant of currentCompany?.plantList; track plant.plant_id) {
            <mat-option [value]="plant.plant_id">{{ plant.plant_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-group span4">
        <mat-label>Shop</mat-label>
        <mat-select formControlName="shop_id">
          <mat-option value="" disabled>-- Select Shop --</mat-option>
          @for (shop of currentPlant?.shopList; track shop.shop_id) {
            <mat-option [value]="shop.shop_id">{{ shop.shop_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="actions-row">
        <button mat-raised-button color="primary" (click)="launchCalculator()">
          Open DT Calculator
        </button>
      </div>
    </div>

    @if (calculatorPayload) {
      <app-cost-calculator [inputPayload]="calculatorPayload" [standaloneMode]="true"></app-cost-calculator>
    }
  </section>
}